import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

export const GET_STOREFRONT_COLLECTIONS = gql`
  query storefrontCollections {
    storefrontCollections {
      next
      items {
        id
        name
      }
    }
  }
`;

const useStorefrontCollections = () => {
  // Set ssr to false to avoid an error preventing algolia from working
  // TODO: need to find an actual reason of this error in the future
  const { loading, error, data } = useQuery(GET_STOREFRONT_COLLECTIONS, {
    ssr: false,
    fetchPolicy: "no-cache",
  });

  return { loading, error, collections: data?.storefrontCollections?.items };
};

export { useStorefrontCollections };
